// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --bg: #f6f7fb;
  --panel: #ffffff;
  --panel2:#f1f5ff;
  --muted:#475569;
  --text:#0f172a;
  --sub:#334155;
  --line: rgba(2,6,23,0.10);
  --line2: rgba(2,6,23,0.14);
  --accent:#7c3aed;
  --accent2:#22c55e;
  --warn:#f59e0b;
  --danger:#ef4444;
  --shadow: 0 14px 40px rgba(2,6,23,0.10);
  --mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --sans: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji","Segoe UI Emoji";
}

*{box-sizing:border-box}
html,body{height:100%}
body{
  margin:0;
  font-family: var(--sans);
  color: var(--text);
  background: radial-gradient(1200px 600px at 20% 0%, rgba(124,58,237,0.12), transparent 60%),
              radial-gradient(900px 500px at 90% 30%, rgba(34,197,94,0.10), transparent 60%),
              radial-gradient(900px 500px at 50% 100%, rgba(59,130,246,0.10), transparent 60%),
              var(--bg);
}

.app{
  height: 100%;
  display:flex;
  flex-direction:column;
}

.topbar{
  position: relative;
  overflow: hidden;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--line);
  background: rgba(255,255,255,0.48);
  backdrop-filter: blur(10px);
  transition: background 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}

.topbar.dragOver{
  background: linear-gradient(180deg, rgba(124,58,237,0.28), rgba(34,197,94,0.20));
  border-bottom-color: rgba(124,58,237,0.65);
  box-shadow: inset 0 0 0 2px rgba(124,58,237,0.45);
}

.dropHint{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(15,23,42,0.46);
  pointer-events: none;
  user-select: none;
}

.topbar.dragOver .dropHint{
  color: rgba(255,255,255,0.96);
  font-weight: 700;
  text-shadow: 0 1px 0 rgba(0,0,0,0.16);
}

.brandTitle{font-weight:700; letter-spacing:0.2px}
.brandSubtitle{font-size:12px; color: rgba(15,23,42,0.62)}
.brandTitleRow{display:flex; align-items:center; gap:10px}
.aboutBtn{padding: 4px 8px; border-radius: 999px; font-size: 12px}

.toolbar{display:flex; gap:10px; align-items:center}
.brand, .toolbar{position: relative; z-index: 1}
.fileButton{
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding: 8px 10px;
  border: 1px solid var(--line2);
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(124,58,237,0.14), rgba(124,58,237,0.06));
  cursor:pointer;
  user-select:none;
  box-shadow: 0 8px 22px rgba(2,6,23,0.08);
}
.fileButton input{display:none}
.fileButton:hover{border-color: rgba(124,58,237,0.6)}

button{
  font: inherit;
  color: var(--text);
  border: 1px solid var(--line2);
  background: rgba(2,6,23,0.03);
  border-radius: 10px;
  padding: 8px 10px;
  cursor:pointer;
}
button:hover{background: rgba(2,6,23,0.06)}
button:active{transform: translateY(1px)}
.zdb {
  padding: 3px 5px;
  border-radius: 6px;
  margin:0;
}

.hidden{display:none !important}
.modalOverlay{
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,0.45);
  display: grid;
  place-items: center;
  padding: 16px;
  z-index: 50;
}
.modal{
  width: min(720px, 92vw);
  max-height: min(80vh, 680px);
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid rgba(255,255,255,0.25);
  background: rgba(255,255,255,0.92);
  box-shadow: 0 24px 80px rgba(2,6,23,0.30);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
}
.modalHeader{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  background: rgba(241,245,255,0.78);
}
.modalTitle{font-weight:800}
.modalBody{
  padding: 12px;
  overflow: auto;
  color: rgba(15,23,42,0.86);
  font-size: 90%;
}
.modalFooter{
  padding: 10px 12px;
  border-top: 1px solid var(--line);
  display:flex;
  justify-content:flex-end;
  gap: 8px;
  background: rgba(2,6,23,0.02);
}
.aboutName{font-weight:900; font-size: 16px; margin-bottom: 2px}
.aboutSub{color: rgba(15,23,42,0.65); margin-bottom: 10px}
.aboutMeta{margin-bottom: 10px}
.aboutHint{color: rgba(15,23,42,0.70)}
.mono{font-family: var(--mono)}

.tabs{
  border-bottom: 1px solid var(--line);
  background: rgba(2,6,23,0.02);
}
.tabsRow{
  display:flex;
  gap: 6px;
  padding: 8px 10px;
  overflow:auto;
}
.tab{
  display:flex;
  align-items:center;
  gap: 10px;
  padding: 4px 5px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: rgba(2,6,23,0.02);
  cursor:pointer;
  white-space:nowrap;
}
.tab.active{
  background: linear-gradient(180deg, rgba(124,58,237,0.22), rgba(124,58,237,0.08));
  border-color: rgba(124,58,237,0.55);
}
.tabName{font-weight:600; font-size: 90%;vertical-align: middle;}
.tabMeta{
  font-size: 10px;
  color: rgba(15,23,42,0.62);
  font-family: var(--mono);
  vertical-align: middle;
}
.tabClose{
  width: 26px;
  height: 26px;
  border-radius: 999px;
  display:grid;
  place-items:center;
  border: 1px solid var(--line);
  background: rgba(2,6,23,0.03);
}
.tabClose:hover{border-color: rgba(239,68,68,0.65)}

.content{
  flex: 1;
  min-height: 0;
  display:grid;
  grid-template-columns: minmax(320px, 42%) 1fr;
  gap: 12px;
  padding: 12px;
}

.leftPane, .rightPane{
  min-height:0;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(255,255,255,0.70);
  box-shadow: var(--shadow);
  overflow:hidden;
}

.leftPane{
  display:grid;
  grid-template-rows: auto 1fr;
}
.leftTop{
  padding: 12px;
  border-bottom: 1px solid var(--line);
  background: rgba(241,245,255,0.78);
}
.searchRow{
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.field label{
  display:block;
  font-size: 12px;
  color: rgba(15,23,42,0.70);
  margin-bottom: 6px;
}
.fieldInline{
  display:flex;
  gap: 8px;
}
input[type="text"]{
  flex:1;
  padding: 9px 10px;
  border-radius: 10px;
  border: 1px solid var(--line2);
  background: rgba(255,255,255,0.85);
  color: var(--text);
  outline:none;
  font-family: var(--mono);
}
input[type="text"]:focus{
  border-color: rgba(124,58,237,0.6);
  box-shadow: 0 0 0 3px rgba(124,58,237,0.20);
}
.hint{
  margin-top: 6px;
  font-size: 12px;
  color: rgba(15,23,42,0.58);
}

.statusRow{
  margin-top: 10px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 10px;
}
.statusText{
  font-size: 12px;
  color: rgba(15,23,42,0.62);
}
.statusActions{display:flex; gap: 8px}

.leftBottom{
  min-height:0;
  display:flex;
  flex-direction:column;
}
.treeHeader{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}
.treeTitle{font-weight:700}
.treeMeta{
  font-size: 12px;
  color: rgba(15,23,42,0.62);
  font-family: var(--mono);
}
.tree{
  min-height:0;
  overflow:auto;
  padding: 8px;
  font-size: 14px;
}

.node{
  padding-left: 10px;
}
.node details{
  border-left: 1px dashed rgba(2,6,23,0.14);
  margin-left: 6px;
  padding-left: 10px;
}
.node summary{list-style:none}
.node summary::-webkit-details-marker{display:none}
.node summary::marker{content:""}
/* keep summary semantics for proper details toggle */
.nodeRowSummary,
.nodeRowLeaf{
  width: 100%;
  text-align: left;
  padding: 3px 5px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  cursor:pointer;
}
.nodeRowSummary:hover,
.nodeRowLeaf:hover{background: rgba(2,6,23,0.04)}
.nodeRowSummary:focus-visible,
.nodeRowLeaf:focus-visible{
  outline: none;
  border-color: rgba(124,58,237,0.45);
  box-shadow: 0 0 0 3px rgba(124,58,237,0.14);
}
.nodeRowContent{
  display:flex;
  align-items:center;
  gap: 6px;
}
.treeExpanderSlot{
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  display: inline-grid;
  place-items: center;
}
.treeExpander{
  width: 20px;
  height: 20px;
  border-radius: 6px;
  padding: 0;
  line-height: 1;
  font-weight: 700;
  display: inline-grid;
  place-items: center;
}
.treeExpanderSpacer{
  visibility: hidden;
  pointer-events: none;
}
.badge{
  font-family: var(--mono);
  font-size: 10.5px;
  padding: 1px 6px;
  border-radius: 999px;
  border: 1px solid rgba(2,6,23,0.14);
  color: rgba(15,23,42,0.70);
  background: rgba(2,6,23,0.03);
}
.badge.accent{border-color: rgba(124,58,237,0.6); color: rgba(91,33,182,0.92)}
.badge.green{border-color: rgba(34,197,94,0.6); color: rgba(21,128,61,0.92)}
.nodeLabel{
  font-weight: 600;
}
.nodeSub{
  font-size: 12px;
  color: rgba(15,23,42,0.55);
  font-family: var(--mono);
}
.selected{
  outline: 1px solid rgba(34,197,94,0.55);
  background: rgba(34,197,94,0.12) !important;
}

.rightPane{
  display:flex;
  flex-direction:column;
}
.detailsHeader{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  background: rgba(241,245,255,0.78);
}
.detailsTitle{font-weight:700}
.detailsBreadcrumb{
  font-size: 12px;
  color: rgba(15,23,42,0.62);
  font-family: var(--mono);
  text-align:right;
  max-width: 62%;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.details{
  min-height:0;
  overflow:auto;
  padding: 12px;
}

.emptyState{
  border: 1px dashed rgba(2,6,23,0.14);
  border-radius: 14px;
  padding: 18px;
  background: rgba(2,6,23,0.02);
}
.emptyTitle{font-weight:800; margin-bottom: 6px}
.emptyBody{color: rgba(15,23,42,0.62)}

.kv{
  display:grid;
  grid-template-columns: 160px 1fr;
  gap: 10px 14px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(2,6,23,0.02);
  margin-bottom: 12px;
}
.k{color: rgba(15,23,42,0.62); font-size:12px}
.v{font-family: var(--mono); font-size: 12px; color: rgba(15,23,42,0.92); overflow-wrap:anywhere}

.detailsSummaryWrap{
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(2,6,23,0.02);
  margin-bottom: 12px;
  overflow:auto;
}
.detailsSummary{
  width:100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
}
.detailsSummary th,
.detailsSummary td{
  border-bottom: 1px solid rgba(2,6,23,0.08);
  border-right: 1px solid rgba(2,6,23,0.08);
  padding: 7px 9px;
  vertical-align: top;
}
.detailsSummary th{
  width: 18%;
  color: rgba(15,23,42,0.62);
  font-weight: 700;
  text-align:left;
  background: rgba(241,245,255,0.58);
}
.detailsSummary td{
  width: 32%;
  color: rgba(15,23,42,0.92);
  overflow-wrap:anywhere;
}
.detailsSummary .num{
  font-family: var(--mono);
  white-space: nowrap;
}

.details > .properties{
  margin-left:0;
}

.properties{
  border: 1px solid var(--line);
  border-radius: 14px;
  overflow:hidden;
  background: rgba(2,6,23,0.02);
  margin-top: 12px;
  margin-left: 1em;
}
.propertiesHeader{
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  font-weight: 700;
}
.propertiesBody{
  padding: 10px 12px;
  overflow:auto;
}

table.blockProperties, table.subBlock{
  width:100%;
  border-collapse: collapse;
  font-size: 13px;
}
table.blockProperties td, table.subBlock td{
  border-bottom: 1px solid rgba(2,6,23,0.08);
  padding: 6px 6px;
  vertical-align: top;
}
table.blockProperties td:first-child{
  width: 1%;
  white-space: nowrap;
  font-weight: 600;
  color: rgba(15,23,42,0.72);
}
table.blockProperties td {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}
table.blockProperties td:last-child {
  width: 100%;
  white-space: nowrap;
}
table.zenParams td:nth-child(2){
  width: 100%;
}
table.zenParams td:last-child{
  width: 1%;
}
table.zenParams .num{
  font-family: var(--mono);
  text-align:right;
  white-space: nowrap;
}

table.subBlock td:first-child{
  color: rgba(15,23,42,0.72);
}
ch{
  color: rgba(180,83,9,0.95);
  font-weight:700;
}

.errorBox{
  border: 1px solid rgba(239,68,68,0.40);
  border-radius: 14px;
  background: rgba(239,68,68,0.08);
  padding: 12px;
  color: rgba(127,29,29,0.95);
  font-family: var(--mono);
  font-size: 12px;
  overflow:auto;
}

.codeBox{
  border: 1px solid var(--line);
  border-radius: 14px;
  background: rgba(2,6,23,0.02);
  padding: 12px;
  font-family: var(--mono);
  font-size: 12px;
  white-space: pre-wrap;
  overflow:auto;
}

@media (max-width: 1050px){
  .content{grid-template-columns: 1fr}
  .searchRow{grid-template-columns: 1fr}
  .detailsBreadcrumb{max-width: 52%}
}

.arrayTable td {
  border-left: 1px solid var(--line);
  border-top: 1px solid var(--line);
}

.propid {
  color: rgba(15,23,42,0.55);
  font-family: var(--mono);
  text-align: right;
  padding-right: 10px;
}

.properties {
  background: hsl(260, 75%, 97%);  
}

.properties tr:nth-child(even) {
  background: hsl(260, 75%, 98%);  
}

.properties .properties {
  background: hsl( 120, 80%, 97%);  
}

.properties .properties tr:nth-child(even) {
  background: hsl( 120, 80%, 98%);  
}

.properties .properties .properties {
  background: hsl( 80, 80%, 97%);  
}

.properties .properties .properties tr:nth-child(even) {
  background: hsl( 80, 80%, 98%);  
}

.properties .properties .properties .properties {
  background: hsl( 0, 80%, 97%);  
}

.properties .properties .properties .properties tr:nth-child(even)  {
  background: hsl( 0, 80%, 98%);  
}

.properties .properties .properties .properties .properties {
  background: hsl( 160, 80%, 97%);  
}
.properties .properties .properties .properties .properties tr:nth-child(even)  {
  background: hsl( 160, 80%, 98%);  
}`, "",{"version":3,"sources":["webpack://./styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,0GAA0G;EAC1G,yHAAyH;AAC3H;;AAEA,EAAE,qBAAqB;AACvB,UAAU,WAAW;AACrB;EACE,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB;;;uBAGqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA;EACE,gFAAgF;EAChF,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,YAAY,eAAe,EAAE,oBAAoB;AACjD,eAAe,cAAc,EAAE,0BAA0B;AACzD,eAAe,YAAY,EAAE,kBAAkB,EAAE,QAAQ;AACzD,UAAU,gBAAgB,EAAE,oBAAoB,EAAE,eAAe;;AAEjE,SAAS,YAAY,EAAE,QAAQ,EAAE,kBAAkB;AACnD,iBAAiB,kBAAkB,EAAE,UAAU;AAC/C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,iFAAiF;EACjF,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;AACA,kBAAkB,YAAY;AAC9B,kBAAkB,kCAAkC;;AAEpD;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA,aAAa,6BAA6B;AAC1C,cAAc,0BAA0B;AACxC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,QAAQ,uBAAuB;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;EAClC,yCAAyC;EACzC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;AACpC;AACA,YAAY,eAAe;AAC3B;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,6BAA6B;AAC/B;AACA,WAAW,eAAe,EAAE,eAAe,EAAE,kBAAkB;AAC/D,UAAU,0BAA0B,EAAE,mBAAmB;AACzD,WAAW,mBAAmB;AAC9B,WAAW,0BAA0B;AACrC,MAAM,wBAAwB;;AAE9B;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iFAAiF;EACjF,mCAAmC;AACrC;AACA,SAAS,eAAe,EAAE,cAAc,CAAC,sBAAsB,CAAC;AAChE;EACE,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA,gBAAgB,kCAAkC;;AAElD;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,6CAA6C;EAC7C,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,QAAQ;AACV;AACA;EACE,MAAM;EACN,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA,eAAe,YAAY,EAAE,QAAQ;;AAErC;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;AACA,WAAW,eAAe;AAC1B;EACE,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;AACA,cAAc,eAAe;AAC7B,sCAAsC,YAAY;AAClD,sBAAsB,UAAU;AAChC,qDAAqD;AACrD;;EAEE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;AAChB;AACA;mBACmB,6BAA6B;AAChD;;EAEE,aAAa;EACb,mCAAmC;EACnC,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA,cAAc,kCAAkC,EAAE,2BAA2B;AAC7E,aAAa,iCAAiC,EAAE,2BAA2B;AAC3E;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;AACpC;AACA,cAAc,eAAe;AAC7B;EACE,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;AACA,YAAY,eAAe,EAAE,kBAAkB;AAC/C,WAAW,0BAA0B;;AAErC;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA,GAAG,0BAA0B,EAAE,cAAc;AAC7C,GAAG,wBAAwB,EAAE,eAAe,EAAE,0BAA0B,EAAE,sBAAsB;;AAEhG;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,0CAA0C;EAC1C,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,SAAS,0BAA0B;EACnC,WAAW,0BAA0B;EACrC,mBAAmB,cAAc;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC","sourcesContent":[":root{\n  --bg: #f6f7fb;\n  --panel: #ffffff;\n  --panel2:#f1f5ff;\n  --muted:#475569;\n  --text:#0f172a;\n  --sub:#334155;\n  --line: rgba(2,6,23,0.10);\n  --line2: rgba(2,6,23,0.14);\n  --accent:#7c3aed;\n  --accent2:#22c55e;\n  --warn:#f59e0b;\n  --danger:#ef4444;\n  --shadow: 0 14px 40px rgba(2,6,23,0.10);\n  --mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --sans: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, \"Apple Color Emoji\",\"Segoe UI Emoji\";\n}\n\n*{box-sizing:border-box}\nhtml,body{height:100%}\nbody{\n  margin:0;\n  font-family: var(--sans);\n  color: var(--text);\n  background: radial-gradient(1200px 600px at 20% 0%, rgba(124,58,237,0.12), transparent 60%),\n              radial-gradient(900px 500px at 90% 30%, rgba(34,197,94,0.10), transparent 60%),\n              radial-gradient(900px 500px at 50% 100%, rgba(59,130,246,0.10), transparent 60%),\n              var(--bg);\n}\n\n.app{\n  height: 100%;\n  display:flex;\n  flex-direction:column;\n}\n\n.topbar{\n  position: relative;\n  overflow: hidden;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--line);\n  background: rgba(255,255,255,0.48);\n  backdrop-filter: blur(10px);\n  transition: background 140ms ease, border-color 140ms ease, box-shadow 140ms ease;\n}\n\n.topbar.dragOver{\n  background: linear-gradient(180deg, rgba(124,58,237,0.28), rgba(34,197,94,0.20));\n  border-bottom-color: rgba(124,58,237,0.65);\n  box-shadow: inset 0 0 0 2px rgba(124,58,237,0.45);\n}\n\n.dropHint{\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(15,23,42,0.46);\n  pointer-events: none;\n  user-select: none;\n}\n\n.topbar.dragOver .dropHint{\n  color: rgba(255,255,255,0.96);\n  font-weight: 700;\n  text-shadow: 0 1px 0 rgba(0,0,0,0.16);\n}\n\n.brandTitle{font-weight:700; letter-spacing:0.2px}\n.brandSubtitle{font-size:12px; color: rgba(15,23,42,0.62)}\n.brandTitleRow{display:flex; align-items:center; gap:10px}\n.aboutBtn{padding: 4px 8px; border-radius: 999px; font-size: 12px}\n\n.toolbar{display:flex; gap:10px; align-items:center}\n.brand, .toolbar{position: relative; z-index: 1}\n.fileButton{\n  display:inline-flex;\n  align-items:center;\n  gap:8px;\n  padding: 8px 10px;\n  border: 1px solid var(--line2);\n  border-radius: 10px;\n  background: linear-gradient(180deg, rgba(124,58,237,0.14), rgba(124,58,237,0.06));\n  cursor:pointer;\n  user-select:none;\n  box-shadow: 0 8px 22px rgba(2,6,23,0.08);\n}\n.fileButton input{display:none}\n.fileButton:hover{border-color: rgba(124,58,237,0.6)}\n\nbutton{\n  font: inherit;\n  color: var(--text);\n  border: 1px solid var(--line2);\n  background: rgba(2,6,23,0.03);\n  border-radius: 10px;\n  padding: 8px 10px;\n  cursor:pointer;\n}\nbutton:hover{background: rgba(2,6,23,0.06)}\nbutton:active{transform: translateY(1px)}\n.zdb {\n  padding: 3px 5px;\n  border-radius: 6px;\n  margin:0;\n}\n\n.hidden{display:none !important}\n.modalOverlay{\n  position: fixed;\n  inset: 0;\n  background: rgba(2,6,23,0.45);\n  display: grid;\n  place-items: center;\n  padding: 16px;\n  z-index: 50;\n}\n.modal{\n  width: min(720px, 92vw);\n  max-height: min(80vh, 680px);\n  overflow: hidden;\n  border-radius: 14px;\n  border: 1px solid rgba(255,255,255,0.25);\n  background: rgba(255,255,255,0.92);\n  box-shadow: 0 24px 80px rgba(2,6,23,0.30);\n  backdrop-filter: blur(10px);\n  display: flex;\n  flex-direction: column;\n}\n.modalHeader{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--line);\n  background: rgba(241,245,255,0.78);\n}\n.modalTitle{font-weight:800}\n.modalBody{\n  padding: 12px;\n  overflow: auto;\n  color: rgba(15,23,42,0.86);\n  font-size: 90%;\n}\n.modalFooter{\n  padding: 10px 12px;\n  border-top: 1px solid var(--line);\n  display:flex;\n  justify-content:flex-end;\n  gap: 8px;\n  background: rgba(2,6,23,0.02);\n}\n.aboutName{font-weight:900; font-size: 16px; margin-bottom: 2px}\n.aboutSub{color: rgba(15,23,42,0.65); margin-bottom: 10px}\n.aboutMeta{margin-bottom: 10px}\n.aboutHint{color: rgba(15,23,42,0.70)}\n.mono{font-family: var(--mono)}\n\n.tabs{\n  border-bottom: 1px solid var(--line);\n  background: rgba(2,6,23,0.02);\n}\n.tabsRow{\n  display:flex;\n  gap: 6px;\n  padding: 8px 10px;\n  overflow:auto;\n}\n.tab{\n  display:flex;\n  align-items:center;\n  gap: 10px;\n  padding: 4px 5px;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  background: rgba(2,6,23,0.02);\n  cursor:pointer;\n  white-space:nowrap;\n}\n.tab.active{\n  background: linear-gradient(180deg, rgba(124,58,237,0.22), rgba(124,58,237,0.08));\n  border-color: rgba(124,58,237,0.55);\n}\n.tabName{font-weight:600; font-size: 90%;vertical-align: middle;}\n.tabMeta{\n  font-size: 10px;\n  color: rgba(15,23,42,0.62);\n  font-family: var(--mono);\n  vertical-align: middle;\n}\n.tabClose{\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  display:grid;\n  place-items:center;\n  border: 1px solid var(--line);\n  background: rgba(2,6,23,0.03);\n}\n.tabClose:hover{border-color: rgba(239,68,68,0.65)}\n\n.content{\n  flex: 1;\n  min-height: 0;\n  display:grid;\n  grid-template-columns: minmax(320px, 42%) 1fr;\n  gap: 12px;\n  padding: 12px;\n}\n\n.leftPane, .rightPane{\n  min-height:0;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: rgba(255,255,255,0.70);\n  box-shadow: var(--shadow);\n  overflow:hidden;\n}\n\n.leftPane{\n  display:grid;\n  grid-template-rows: auto 1fr;\n}\n.leftTop{\n  padding: 12px;\n  border-bottom: 1px solid var(--line);\n  background: rgba(241,245,255,0.78);\n}\n.searchRow{\n  display:grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.field label{\n  display:block;\n  font-size: 12px;\n  color: rgba(15,23,42,0.70);\n  margin-bottom: 6px;\n}\n.fieldInline{\n  display:flex;\n  gap: 8px;\n}\ninput[type=\"text\"]{\n  flex:1;\n  padding: 9px 10px;\n  border-radius: 10px;\n  border: 1px solid var(--line2);\n  background: rgba(255,255,255,0.85);\n  color: var(--text);\n  outline:none;\n  font-family: var(--mono);\n}\ninput[type=\"text\"]:focus{\n  border-color: rgba(124,58,237,0.6);\n  box-shadow: 0 0 0 3px rgba(124,58,237,0.20);\n}\n.hint{\n  margin-top: 6px;\n  font-size: 12px;\n  color: rgba(15,23,42,0.58);\n}\n\n.statusRow{\n  margin-top: 10px;\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap: 10px;\n}\n.statusText{\n  font-size: 12px;\n  color: rgba(15,23,42,0.62);\n}\n.statusActions{display:flex; gap: 8px}\n\n.leftBottom{\n  min-height:0;\n  display:flex;\n  flex-direction:column;\n}\n.treeHeader{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--line);\n}\n.treeTitle{font-weight:700}\n.treeMeta{\n  font-size: 12px;\n  color: rgba(15,23,42,0.62);\n  font-family: var(--mono);\n}\n.tree{\n  min-height:0;\n  overflow:auto;\n  padding: 8px;\n  font-size: 14px;\n}\n\n.node{\n  padding-left: 10px;\n}\n.node details{\n  border-left: 1px dashed rgba(2,6,23,0.14);\n  margin-left: 6px;\n  padding-left: 10px;\n}\n.node summary{list-style:none}\n.node summary::-webkit-details-marker{display:none}\n.node summary::marker{content:\"\"}\n/* keep summary semantics for proper details toggle */\n.nodeRowSummary,\n.nodeRowLeaf{\n  width: 100%;\n  text-align: left;\n  padding: 3px 5px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor:pointer;\n}\n.nodeRowSummary:hover,\n.nodeRowLeaf:hover{background: rgba(2,6,23,0.04)}\n.nodeRowSummary:focus-visible,\n.nodeRowLeaf:focus-visible{\n  outline: none;\n  border-color: rgba(124,58,237,0.45);\n  box-shadow: 0 0 0 3px rgba(124,58,237,0.14);\n}\n.nodeRowContent{\n  display:flex;\n  align-items:center;\n  gap: 6px;\n}\n.treeExpanderSlot{\n  flex: 0 0 20px;\n  width: 20px;\n  height: 20px;\n  display: inline-grid;\n  place-items: center;\n}\n.treeExpander{\n  width: 20px;\n  height: 20px;\n  border-radius: 6px;\n  padding: 0;\n  line-height: 1;\n  font-weight: 700;\n  display: inline-grid;\n  place-items: center;\n}\n.treeExpanderSpacer{\n  visibility: hidden;\n  pointer-events: none;\n}\n.badge{\n  font-family: var(--mono);\n  font-size: 10.5px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  border: 1px solid rgba(2,6,23,0.14);\n  color: rgba(15,23,42,0.70);\n  background: rgba(2,6,23,0.03);\n}\n.badge.accent{border-color: rgba(124,58,237,0.6); color: rgba(91,33,182,0.92)}\n.badge.green{border-color: rgba(34,197,94,0.6); color: rgba(21,128,61,0.92)}\n.nodeLabel{\n  font-weight: 600;\n}\n.nodeSub{\n  font-size: 12px;\n  color: rgba(15,23,42,0.55);\n  font-family: var(--mono);\n}\n.selected{\n  outline: 1px solid rgba(34,197,94,0.55);\n  background: rgba(34,197,94,0.12) !important;\n}\n\n.rightPane{\n  display:flex;\n  flex-direction:column;\n}\n.detailsHeader{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--line);\n  background: rgba(241,245,255,0.78);\n}\n.detailsTitle{font-weight:700}\n.detailsBreadcrumb{\n  font-size: 12px;\n  color: rgba(15,23,42,0.62);\n  font-family: var(--mono);\n  text-align:right;\n  max-width: 62%;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n}\n.details{\n  min-height:0;\n  overflow:auto;\n  padding: 12px;\n}\n\n.emptyState{\n  border: 1px dashed rgba(2,6,23,0.14);\n  border-radius: 14px;\n  padding: 18px;\n  background: rgba(2,6,23,0.02);\n}\n.emptyTitle{font-weight:800; margin-bottom: 6px}\n.emptyBody{color: rgba(15,23,42,0.62)}\n\n.kv{\n  display:grid;\n  grid-template-columns: 160px 1fr;\n  gap: 10px 14px;\n  padding: 10px 12px;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: rgba(2,6,23,0.02);\n  margin-bottom: 12px;\n}\n.k{color: rgba(15,23,42,0.62); font-size:12px}\n.v{font-family: var(--mono); font-size: 12px; color: rgba(15,23,42,0.92); overflow-wrap:anywhere}\n\n.detailsSummaryWrap{\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: rgba(2,6,23,0.02);\n  margin-bottom: 12px;\n  overflow:auto;\n}\n.detailsSummary{\n  width:100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  font-size: 12px;\n}\n.detailsSummary th,\n.detailsSummary td{\n  border-bottom: 1px solid rgba(2,6,23,0.08);\n  border-right: 1px solid rgba(2,6,23,0.08);\n  padding: 7px 9px;\n  vertical-align: top;\n}\n.detailsSummary th{\n  width: 18%;\n  color: rgba(15,23,42,0.62);\n  font-weight: 700;\n  text-align:left;\n  background: rgba(241,245,255,0.58);\n}\n.detailsSummary td{\n  width: 32%;\n  color: rgba(15,23,42,0.92);\n  overflow-wrap:anywhere;\n}\n.detailsSummary .num{\n  font-family: var(--mono);\n  white-space: nowrap;\n}\n\n.details > .properties{\n  margin-left:0;\n}\n\n.properties{\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  overflow:hidden;\n  background: rgba(2,6,23,0.02);\n  margin-top: 12px;\n  margin-left: 1em;\n}\n.propertiesHeader{\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--line);\n  font-weight: 700;\n}\n.propertiesBody{\n  padding: 10px 12px;\n  overflow:auto;\n}\n\ntable.blockProperties, table.subBlock{\n  width:100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\ntable.blockProperties td, table.subBlock td{\n  border-bottom: 1px solid rgba(2,6,23,0.08);\n  padding: 6px 6px;\n  vertical-align: top;\n}\ntable.blockProperties td:first-child{\n  width: 1%;\n  white-space: nowrap;\n  font-weight: 600;\n  color: rgba(15,23,42,0.72);\n}\ntable.blockProperties td {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle;\n}\ntable.blockProperties td:last-child {\n  width: 100%;\n  white-space: nowrap;\n}\ntable.zenParams td:nth-child(2){\n  width: 100%;\n}\ntable.zenParams td:last-child{\n  width: 1%;\n}\ntable.zenParams .num{\n  font-family: var(--mono);\n  text-align:right;\n  white-space: nowrap;\n}\n\ntable.subBlock td:first-child{\n  color: rgba(15,23,42,0.72);\n}\nch{\n  color: rgba(180,83,9,0.95);\n  font-weight:700;\n}\n\n.errorBox{\n  border: 1px solid rgba(239,68,68,0.40);\n  border-radius: 14px;\n  background: rgba(239,68,68,0.08);\n  padding: 12px;\n  color: rgba(127,29,29,0.95);\n  font-family: var(--mono);\n  font-size: 12px;\n  overflow:auto;\n}\n\n.codeBox{\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: rgba(2,6,23,0.02);\n  padding: 12px;\n  font-family: var(--mono);\n  font-size: 12px;\n  white-space: pre-wrap;\n  overflow:auto;\n}\n\n@media (max-width: 1050px){\n  .content{grid-template-columns: 1fr}\n  .searchRow{grid-template-columns: 1fr}\n  .detailsBreadcrumb{max-width: 52%}\n}\n\n.arrayTable td {\n  border-left: 1px solid var(--line);\n  border-top: 1px solid var(--line);\n}\n\n.propid {\n  color: rgba(15,23,42,0.55);\n  font-family: var(--mono);\n  text-align: right;\n  padding-right: 10px;\n}\n\n.properties {\n  background: hsl(260, 75%, 97%);  \n}\n\n.properties tr:nth-child(even) {\n  background: hsl(260, 75%, 98%);  \n}\n\n.properties .properties {\n  background: hsl( 120, 80%, 97%);  \n}\n\n.properties .properties tr:nth-child(even) {\n  background: hsl( 120, 80%, 98%);  \n}\n\n.properties .properties .properties {\n  background: hsl( 80, 80%, 97%);  \n}\n\n.properties .properties .properties tr:nth-child(even) {\n  background: hsl( 80, 80%, 98%);  \n}\n\n.properties .properties .properties .properties {\n  background: hsl( 0, 80%, 97%);  \n}\n\n.properties .properties .properties .properties tr:nth-child(even)  {\n  background: hsl( 0, 80%, 98%);  \n}\n\n.properties .properties .properties .properties .properties {\n  background: hsl( 160, 80%, 97%);  \n}\n.properties .properties .properties .properties .properties tr:nth-child(even)  {\n  background: hsl( 160, 80%, 98%);  \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
